export default __webpack_public_path__ + "static/media/ds.90dc9c37.svg";